module.exports = __webpack_public_path__ + "media/Introducing_Newtide.a3556a93.mp3";